import { repeat } from './utils';

export const generateHtmlTemplate = (translate: (key: string) => string): string => {
  const hours = Array.from({ length: 24 }, (_, hour) => hour.toString().padStart(2, '0'))
    .map(
      hour =>
        `<button type="button" class="dtp-time-option" data-time-part="hour" data-time-value="${hour}" role="option">${hour}</button>`,
    )
    .join('');
  const minutes = Array.from({ length: 60 }, (_, minute) => minute.toString().padStart(2, '0'))
    .map(
      minute =>
        `<button type="button" class="dtp-time-option" data-time-part="minute" data-time-value="${minute}" role="option">${minute}</button>`,
    )
    .join('');

  return `
        <div class="dtp-backdrop" aria-hidden="true"></div>
        <div class="dtp-wrapper" role="dialog" aria-modal="true" aria-label="${translate('date picker')}">
            <div class="dtp-date">
                <div class="dtp-month-and-year-header">
                    <button type="button" class="month" aria-label="${translate('select month')}"></button>
                    <button type="button" class="year" aria-label="${translate('select year')}"></button>
                </div>
                <div class="dtp-select-pane">
                    <div class="dtp-time" aria-live="polite">12:00</div>
                </div>
                <div class="dtp-picker-section">
                    <div class="dtp-calender-section">
                        <div class="dtp-month-switcher dtp-select-pane">
                            <button type="button" class="dtp-icon dtp-icon-previous" aria-label="${translate('previous month')}"><</button>
                            <div class="dtp-selected-date" aria-live="polite"></div>
                            <button type="button" class="dtp-icon dtp-icon-next" aria-label="${translate('next month')}">></button>
                        </div>
                        <div class="dtp-calender">
                            <table role="grid" aria-label="${translate('calendar')}">
                                <thead>
                                    <tr role="row"><th role="columnheader" aria-label="${translate('sunday')}"></th><th role="columnheader" aria-label="${translate('monday')}"></th><th role="columnheader" aria-label="${translate('tuesday')}"></th><th role="columnheader" aria-label="${translate('wednesday')}"></th><th role="columnheader" aria-label="${translate('thursday')}"></th><th role="columnheader" aria-label="${translate('friday')}"></th><th role="columnheader" aria-label="${translate('saturday')}"></th></tr>
                                </thead>
                                <tbody>
                                    ${repeat(`<tr role="row">${Array(7).fill('<td role="gridcell"></td>').join('')}</tr>`, 6)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="dtp-month-picker-section" hidden>
                        <div class="dtp-month-picker-grid" role="grid" aria-label="${translate('month selection')}"></div>
                    </div>
                    <div class="dtp-year-picker-section" hidden>
                        <div class="dtp-year-picker-nav">
                            <button type="button" class="dtp-icon dtp-year-nav" data-year-nav="-12" aria-label="${translate('previous years')}"><</button>
                            <div class="dtp-year-range" aria-live="polite"></div>
                            <button type="button" class="dtp-icon dtp-year-nav" data-year-nav="12" aria-label="${translate('next years')}">></button>
                        </div>
                        <div class="dtp-year-picker-grid" role="grid" aria-label="${translate('year selection')}"></div>
                    </div>
                    <div class="dtp-time-section">
                        <div class="dtp-time-entry">
                            <input class="dtp-time-manual-input" type="text" inputmode="numeric" autocomplete="off" placeholder="HH:mm" aria-label="${translate('select time')}">
                            <button type="button" class="dtp-time-toggle" aria-label="${translate('select time')}">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <circle cx="12" cy="12" r="9"></circle>
                                    <path d="M12 7v5l3 2"></path>
                                </svg>
                            </button>
                        </div>
                        <div class="dtp-time-grid" aria-label="${translate('select time')}" hidden>
                            <div class="dtp-time-column" data-time-column="hour" role="listbox" aria-label="Hours">${hours}</div>
                            <div class="dtp-time-separator" aria-hidden="true">:</div>
                            <div class="dtp-time-column" data-time-column="minute" role="listbox" aria-label="Minutes">${minutes}</div>
                        </div>
                    </div>
                </div>
                <div class="dtp-bottom-part">
                    <button type="button" class="dtp-cancel-btn dtp-btn" title="${translate('cancel')}" aria-label="${translate('cancel')}">${translate('cancel')}</button>
                    <button type="button" class="dtp-ok-btn dtp-btn" title="${translate('ok')}" aria-label="${translate('ok')}">${translate('ok')}</button>
                </div>
            </div>
        </div>`;
};
